import Phaser from 'phaser';
import { GameScene } from '../GameScene';

/**
 * Layout responsivo de la UI: reposiciona los elementos del HUD (botones del menú, barras, etc.) al
 * cambiar el tamaño de pantalla (layoutUI) y recoloca la consola del sistema + su input de chat
 * (layoutSystemConsole). Extraído de GameScene (god-object). Los elementos del HUD viven en GameScene
 * y se acceden vía `this.scene.*`.
 */
export class LayoutController {
  constructor(private scene: GameScene) {}

  public layoutUI(): void {
    const { width, height } = this.scene.scale;

    // =====================================================================
    // FILA 1: Botones principales (Personaje, Inventario, Config)
    // =====================================================================
    const row1Y = 10;
    const buttonGap = 40;

    if (this.scene.gearButton) {
      this.scene.gearButton.setPosition(width - 20, row1Y);
    }

    // Los botones de Personaje, Inventario y Árbol de Pasivas ahora están en el HUD inferior

    // =====================================================================
    // FILA 2: Botones de debug/desarrollo
    // =====================================================================
    const row2Y = 40;

    // Sol (☀️): vive en la fila 2 (admin/debug), slot libre n=9.
    if (this.scene.sunButton) {
      this.scene.sunButton.setPosition(width - 20 - buttonGap * 9, row2Y);
    }

    if (this.scene.invokeButton) {
      this.scene.invokeButton.setPosition(width - 20, row2Y);
    }

    if (this.scene.itemsButton) {
      this.scene.itemsButton.setPosition(width - 20 - buttonGap, row2Y);
    }

    if (this.scene.bodyGalleryButton) {
      this.scene.bodyGalleryButton.setPosition(width - 20 - buttonGap * 2, row2Y);
    }

    if (this.scene.weaponGalleryButton) {
      this.scene.weaponGalleryButton.setPosition(width - 20 - buttonGap * 5, row2Y);
    }

    if (this.scene.charFrameButton) {
      this.scene.charFrameButton.setPosition(width - 20 - buttonGap * 6, row2Y);
    }

    if (this.scene.animButton) {
      this.scene.animButton.setPosition(width - 20 - buttonGap * 3, row2Y);
    }

    if (this.scene.particleButton) {
      this.scene.particleButton.setPosition(width - 20 - buttonGap * 4, row2Y);
    }

    // Overlay negro a pantalla completa

    if (this.scene.menuOverlay) {
      this.scene.menuOverlay.setPosition(0, 0);

      this.scene.menuOverlay.width = width;

      this.scene.menuOverlay.height = height;
    }

    // Overlay de reconexión

    if (this.scene.reconnectOverlay) {
      this.scene.reconnectOverlay.setPosition(0, 0);

      this.scene.reconnectOverlay.width = width;

      this.scene.reconnectOverlay.height = height;
    }

    if (this.scene.reconnectText) {
      this.scene.reconnectText.setPosition(width / 2, height / 2);
    }

    // Botones del menú centrados

    if (this.scene.menuButtons) {
      const centerX = width / 2;

      const centerY = height / 2;

      this.scene.menuButtons.opciones.setPosition(centerX, centerY - 44);

      this.scene.menuButtons.salir.setPosition(centerX, centerY);

      this.scene.menuButtons.volver.setPosition(centerX, centerY + 44);
    }

    // Panel de opciones: se crea ya centrado con tamaño relativo a la pantalla,

    // no hace falta recolocarlo aquí.

    // HUD inferior derecho: FPS arriba, coordenadas abajo (alineados a la derecha).
    const HUD_LINE_H = 15;

    if (this.scene.coordText) {
      this.scene.coordText.setPosition(width - 8, height - 4).setOrigin(1, 1);
    }

    if (this.scene.fpsText) {
      this.scene.fpsText.setPosition(width - 8, height - 4 - HUD_LINE_H).setOrigin(1, 1);
    }

    // Indicador de zona: esquina abajo-izquierda (donde antes iban las coords)
    if (this.scene.zoneIndicator) {
      this.scene.zoneIndicator.setPosition(8, height - 6);
    }
    // Indicador de barco equipado: pegado a la derecha del de zona.
    if (this.scene.boatIndicator) {
      this.scene.boatIndicator.setPosition(8 + 14 + 4, height - 6);
    }

    // Reposicionar panel de invocar si existe
    this.scene.invokePanel?.moveTo(width / 2, height / 2);

    // Consola de sistema

    this.layoutSystemConsole();
    
    // Actualizar filtros de cámara para separar UI del juego
    this.scene.setupCameraFilters();
  }





  public layoutSystemConsole(): void {
    this.scene.systemConsole?.layout();
  }
}
